import React, { ReactElement } from 'react';
import Checkbox from '../checkbox/checkbox.component';
import FormatService from '../../services/format-service';
import useStylesCheckboxSelectAll from './checkbox-select-all.styles';

const CheckboxSelectAll: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isCard,
    isChecked,
    isIndeterminate,
    id,
    onChange,
  } = props;

  const { classes } = useStylesCheckboxSelectAll();

  const cardClassName: string | undefined = isCard ? classes.checkboxSelectAllCard : undefined;

  return (
    <Checkbox
      id={id}
      className={FormatService.formatClassNames(classes.checkboxSelectAll, cardClassName)}
      isChecked={isChecked}
      isIndeterminate={isIndeterminate}
      onChange={onChange}
    />
  );
});

export default CheckboxSelectAll;
